import { render, staticRenderFns } from "./dischargepatient.vue?vue&type=template&id=f7943500"
import script from "./dischargepatient.vue?vue&type=script&lang=js"
export * from "./dischargepatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports